import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'escapeHTML',
    standalone: false
})
export class EscapeHTMLPipe implements PipeTransform {

    transform(html: string): string {
        if (html === undefined || html === null) {
            return html;
        }
        return html
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

}
